module.exports = __webpack_public_path__ + "static/media/icon.heart.alone.fuschia.7e1b337e.svg";